import type { SceneManager } from '../scene-manager.class';
import type { QualityLevel } from '../../../types/engine.types';
import { DESIGN_PACKAGE_LOOK, DESIGN_PACKAGE_TONE_MAPPING } from '../../../../constants/design-package-look';
import { getQualitySettings } from '../../../../hooks/use-three-kitchen/quality';
import { updateMaterialsForQuality } from '../helpers/update-materials-for-quality.helper';

export interface SetQualityParams {
	quality: QualityLevel;
}

/**
 * Update quality settings
 */
export const setQualityCfn = (self: SceneManager, params: SetQualityParams): void => {
	const { quality } = params;
	const qualitySettings = getQualitySettings(quality);
	self.setQualitySettings(qualitySettings);

	const renderer = self.renderer;
	if (renderer && qualitySettings) {
		// Honor any construction-time pixelRatio override (e.g. iOS memory budget).
		// antialias cannot change post-construction; skip.
		renderer.setPixelRatio(self.config.pixelRatio ?? qualitySettings.pixelRatio);
		renderer.toneMapping = DESIGN_PACKAGE_LOOK ? DESIGN_PACKAGE_TONE_MAPPING : qualitySettings.toneMapping;
		renderer.shadowMap.enabled = qualitySettings.shadowMapEnabled;
		renderer.shadowMap.type = qualitySettings.shadowMapType;
	}

	// Update all materials in the scene for wireframe mode
	const scene = self.scene;
	if (scene && qualitySettings) {
		updateMaterialsForQuality(scene, qualitySettings);
	}
};
